export default __webpack_public_path__ + "atomic/_patterns/02-molecules/seed-calculator-1/_seed-calculator-1.twig";